import isNil from 'lodash/isNil';

import * as types from './types';
import { OrderListAction, OrderListsAction } from './types';
import { OrderListsState, OrderListState } from './state';
import { OrderListActionUpdateName } from './actions';
import { SelectionListOut } from '../api';
import { Orderlist } from '../../../models/OrderList';
import { log } from '../../shared/utils/log';

export function orderlistsReducer(
    orderlists: OrderListsState = { list: [] },
    action: OrderListsAction
): OrderListsState {
    switch (action.type) {
        case types.CREATE_SELECTIONLIST: {
            const newItem = action.payload;
            const newList = [...orderlists.list, newItem];
            return {
                ...orderlists,
                list: newList as Orderlist[],
                active: newItem as Orderlist
            };
        }
        case types.DELETE_SELECTIONLIST: {
            const listId = action.payload;
            const index = orderlists.list.findIndex(item => {
                return item.id === listId;
            });
            // if the list is not found return
            if (index < 0) return orderlists;
            let active = orderlists.active;
            const reducedList = [...orderlists.list.slice(0, index), ...orderlists.list.slice(index + 1)];
            if (active && active.id === action.payload) {
                active = undefined;
                if (reducedList.length > 0) {
                    active = reducedList[0];
                }
            }
            return {
                ...orderlists,
                list: reducedList,
                active,
                loading: true
            };
        }
        case types.SET_ACTIVE_LIST: {
            const listItem = action.payload;
            return { ...orderlists, ...{ active: listItem as Orderlist } };
        }

        case types.SELECTIONLISTS_REQUEST:
            return { ...orderlists, ...{ loading: true } };

        case types.SELECTIONLISTS_SUCCESS: {
            const newOrderlists = action.payload;
            const activeList = Array.isArray(newOrderlists) && newOrderlists.length > 0 ? newOrderlists[0] : undefined;

            return {
                ...orderlists,
                list: newOrderlists as Orderlist[],
                active: activeList as Orderlist,
                loading: false,
                productToSelectionListAnimation: false
            };
        }
        case types.SELECTIONLISTS_FAILURE: {
            const newAttributes = { error: action.error, loading: false } as OrderListsState;
            const list = action.payload;
            if (list) {
                newAttributes.list = list;
            }
            return { ...orderlists, ...newAttributes };
        }
        case types.SELECTIONLISTS_UPDATE_NAME: {
            const updateName = action.payload as OrderListActionUpdateName;
            const updatedList = orderlists.list.map(list => {
                if (list.id === updateName.id) {
                    return { ...list, ...{ listName: updateName.name } };
                } else {
                    return list;
                }
            });
            const updatedActiveList = { ...orderlists.active } as SelectionListOut;
            const activeOrderlistId = orderlists?.active?.id;
            const updatedOrderlistId = updateName.id;
            const updatedOrderlistName = updateName.name;

            if (isNil(activeOrderlistId) || isNil(updatedOrderlistId)) {
                log.error('SelectionListReducer: UPDATE_NAME id was undefined', {
                    payload: JSON.stringify(action?.payload),
                    payloadId: updatedOrderlistId,
                    activeList: JSON.stringify(orderlists?.active),
                    activeId: activeOrderlistId
                });
            }

            if (activeOrderlistId === updatedOrderlistId) {
                updatedActiveList.listName = updatedOrderlistName;
            }
            return {
                ...orderlists,
                active: updatedActiveList as Orderlist,
                list: updatedList
            };
        }
        case types.SELECTIONLIST_SUMMARY_SUCCESS: {
            const selectionList = action.payload;
            const updatedList = orderlists.list.map(list => {
                if (list.id === selectionList.id) {
                    return selectionList;
                } else {
                    return list;
                }
            });

            // @ts-ignore
            updatedList.sort((a, b) => b.lastModifiedAt - a.lastModifiedAt);

            return { ...orderlists, ...{ list: updatedList as Orderlist[] } };
        }
        case types.ADD_TO_LIST:
            return { ...orderlists, ...{ productToSelectionListAnimation: true } };

        case types.SELECTIONLIST_TOGGLE_SELECTIONBAR:
            return {
                ...orderlists,
                selectionListBarExpanded: !orderlists.selectionListBarExpanded
            };

        default:
            return orderlists;
    }
}

const initialListValues: OrderListState = {
    eaudiobooksAmount: 0,
    eaudiobooksValue: 0,
    ebooksAmount: 0,
    ebooksValue: 0,
    currency: '',
    totalValue: 0,
    totalNetValue: 0,
    totalTaxValue: 0,
    listName: '',
    share: {
        show: false,
        link: ''
    }
};

export function orderlistSummaryReducer(
    orderlist: OrderListState = initialListValues,
    action: OrderListAction
): OrderListState {
    switch (action.type) {
        case types.CHANGE_ACTIVE_SELECTIONLIST: {
            return { id: action.payload };
        }

        case types.SELECTIONLISTS_UPDATE_NAME: {
            const updateName = action.payload;
            if (orderlist.id === updateName.id) {
                return { ...orderlist, ...{ listName: updateName.name } };
            } else {
                return orderlist;
            }
        }
        case types.SELECTIONLIST_VISIBILITY: {
            const payload = action.payload;
            return { ...orderlist, shared: payload.shared };
        }
        case types.SELECTIONLIST_SEND_FOR_APPROVAL_ERROR: {
            const errorMsg = action.payload;
            return { ...orderlist, errorMsg: errorMsg, pendingApprovalRequest: false };
        }
        case types.SELECTIONLIST_SEND_FOR_APPROVAL_REQUEST:
            return { ...orderlist, pendingApprovalRequest: true, errorMsg: undefined };
        case types.SELECTIONLIST_SEND_FOR_APPROVAL_SUCCESS:
            return { ...orderlist, pendingApprovalRequest: false };
        case types.SELECTIONLIST_FETCH_REQUIRED_SPOC:
            return { ...orderlist };

        case types.SELECTIONLIST_CLEAR_REQUIRED_SPOC:
            return { ...orderlist, ...{ requiredSpoc: undefined } };

        case types.SELECTIONLIST_FETCH_REQUIRED_SPOC_SUCCESS: {
            const requiredSpoc = action.payload;
            return { ...orderlist, requiredSpoc: requiredSpoc };
        }
        case types.SET_LIST_SHARED_STATE: {
            const shared = action.payload;
            return { ...orderlist, shared };
        }
        default:
            return orderlist;
    }
}
